export const visibilityOptions = ['promote', 'secondary', 'hidden'] as const
